var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-text-field',_vm._g(_vm._b({attrs:{"type":_vm.$_type,"pattern":"[0-9]*","inputmode":"numeric","append-icon":_vm.$_icon},on:{"click:append":_vm.$_onClickIcon}},'core-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }